import styled from 'styled-components';
import { BodyRegular, FlexSmAlignCenter } from 'components/Elements';
import { FormFieldContainer, FormLabel, FormTextInput } from './FormComponents';
import { ConditionalValidationErrorMessage } from './ValidationErrorMessage';
import { theme } from 'theme';
import Hint from 'components/Hint';
import React, { ComponentPropsWithoutRef } from 'react';

type TextFieldProps = {
    fieldName: string;
    labelText: string;
    required?: boolean;
    hint?: string;
    inputAria: string;
    errorMessage?: string;
    hideErrorMessage?: boolean;
    width?: string;
    unitText?: string;
} & ComponentPropsWithoutRef<'input'>;

const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
    (
        {
            fieldName,
            labelText,
            required,
            hint,
            inputAria,
            errorMessage = '',
            hideErrorMessage,
            width = '100%',
            unitText,
            ...props
        },
        ref,
    ) => {
        return (
            <FormFieldContainer>
                <FormLabel id={`${fieldName}Label`} htmlFor={fieldName}>
                    {labelText}
                    {required && ' *'}
                </FormLabel>
                {hint && <Hint hint={hint} />}
                <FlexSmAlignCenter>
                    <FormTextInput
                        ref={ref}
                        id={fieldName}
                        aria-required={required}
                        aria-label={inputAria}
                        $error={!!errorMessage}
                        width={width}
                        {...props}
                    />
                    {unitText && typeof unitText === 'string' && <UnitText>{unitText}</UnitText>}
                    {unitText && typeof unitText !== 'string' && <>{unitText}</>}
                </FlexSmAlignCenter>
                {!hideErrorMessage && <ConditionalValidationErrorMessage error={errorMessage} />}
            </FormFieldContainer>
        );
    },
);

TextField.displayName = 'TextField';

export default TextField;

const UnitText = styled(BodyRegular)`
    color: ${theme.textSecondaryColour};
`;
